import { bool, string } from 'prop-types';

export const propTypes = {
  curationId: string.isRequired,
  preview: bool
};

export const defaultProps = {
  preview: false
};
